import template from './add-custom.html'
import modalTemplate from './confirm.html'

export let addCustom = {
  template: template,
  controllerAs: 'vm',
  controller: ['Validations', 'GlobalConfig', 'Ramda', '$mdDialog', '$cookies', '$state', 'WorkPlanModalSrv', 
  'ReviewSrv', 'Util', 'WorkPlanSrv',
  function addCustomCtrl (Validations, GlobalConfig, Ramda, $mdDialog, $cookies, $state, WorkPlanModalSrv, ReviewSrv, Util, WorkPlanSrv) {
    const curry = Ramda.curry
    const currentModule = $state.current.module
    const { isProductsType, isProjectsType, isExtensionProjectsType, isCrossExtensionProjectsType } = Validations
    const { projectParent, projectChild, productParent, productChild, extensionProjectParent, extensionProjectChild, projectCrossParent, projectCrossChild } = GlobalConfig.minorActivityId
    const objHas = Util.objHas

    const startDateChange = (startDate, minEndDate) => {
      minEndDate = moment(startDate).isValid() ? moment(startDate).add(1, 'days').toDate() : null
    }

    const extractPeriodsIds = (obj) => Object.keys(obj).filter(id => Boolean(obj[id])).map(id => { return { periodId: id } })

    const periodsExist = (arr) => Array.isArray(arr) ? arr.length > 0 : false

    const datesExist = (start, end) => Boolean(start) && Boolean(end)

    const setChildrenId = (parent) => {
      switch (parent) {
        case projectParent:
          return projectChild
        case productParent:
          return productChild
        case extensionProjectParent:
          return extensionProjectChild
        case projectCrossParent:
          return projectCrossChild
      }
    }

    const setActivity = (scope) => {
      return {
        activityId: setChildrenId(scope.parent.activityId),
        teacherId: scope.teacherId,
        workplanId: scope.workplanId,
        name: scope.title,
        description: scope.description,
        hoursPlanning: scope.plannedHours,
        parentActivityId: scope.parent.workplanTeacherActivityId,
        timeRangeTypeId: Number(scope.rangeType),
        origin: 2
      }
    }

    const confirm = (name) => {
      let projectName = this.title
      let createOrEdit = this.activityTag
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          angular.extend(this, {
            name: name,
            projectName: projectName,
            createOrEdit: createOrEdit,
            close: () => $mdDialog.hide()
          })
        }],
        controllerAs: 'vm',
        template: modalTemplate,
        clickOutsideToClose: false
      })
    }

    const addOrEditProject = curry((confirm, parent, activity, name) => {
      switch (true) {
        case isProductsType(parent):
          return ReviewSrv.addCustomActivity.product(activity).$promise.then((dataReturn) => {
            if (dataReturn.status) {
              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
              WorkPlanModalSrv.setVariable(activity)
              $mdDialog.hide()
              // dataReturn.status ? confirm(name) : console.log('error in communications')
            }
          })
        case isProjectsType(parent):
          return ReviewSrv.addCustomActivity.project(activity).$promise.then((dataReturn) => {
            if (dataReturn.status) {
              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
              WorkPlanModalSrv.setVariable(activity)
              $mdDialog.hide()
            // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
            }
          })
        case isExtensionProjectsType(parent):
          return ReviewSrv.addCustomActivity.extensionProject(activity).$promise.then((dataReturn) => {
            // dataReturn.status ? confirm(name) : console.log('error in communications')
            if (dataReturn.status) {
              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
              WorkPlanModalSrv.setVariable(activity)
              $mdDialog.hide()
            // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
            }
          })
        case isCrossExtensionProjectsType(parent):
          return ReviewSrv.addCustomActivity.extensionProject(activity).$promise.then((dataReturn) => {
            // dataReturn.status ? confirm(name) : console.log('error in communications')
            if (dataReturn.status) {
              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
              WorkPlanModalSrv.setVariable(activity)
              $mdDialog.hide()
            // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
            }
          })
      }
    })(confirm)

    const getPeriodList = curry((service, header) => {
      return service.getList(header).$promise
    })(WorkPlanSrv.getDataFormProduct)

    const addActivity = curry((extractPeriodsIds, setActivity, addOrEditProject, scope) => {
      scope.sentForm = true
      let activity = setActivity(scope)
      if (Number(scope.rangeType) === 1) {
        activity.periods = extractPeriodsIds(scope.periodsArray)

        let periodsId = activity.periods.map(period => +period.periodId)

        activity.periodicityName = this.typePeriod
          .filter(period => periodsId.indexOf(period.periodId) !== -1 ? period : null)
          .map(period => period.periodName)
          .join(',')
      } else if (scope.startDate && scope.endDate) {
        activity.startDate = scope.startDate
        activity.endDate = scope.endDate
      }
      if (scope.isEditing) activity.workplanTeacherActivityId = scope.children.workplanTeacherActivityId
      let adding = addOrEditProject(scope.parent, activity, scope.activityTag)
      adding.then(promise => console.log(promise))
    })(extractPeriodsIds, setActivity, addOrEditProject)

    const validPeriods = () => {
      if (Number(this.rangeType) === 1) {
        return periodsExist(extractPeriodsIds(this.periodsArray))
      } else if (Number(this.rangeType) === 2) {
        return datesExist(this.startDate, this.endDate)
      }
    }

    angular.extend(this, { // CONSTANTS
      workplanId: JSON.parse($cookies.get('currentUser')).workplanId,
      teacherId: JSON.parse($cookies.get('currentUser')).teacherId,
      name: JSON.parse($cookies.get('currentUser')).name,
      projectChild: GlobalConfig.minorActivityId.projectChild,
      rangeTypes: GlobalConfig.rangeTypes
    })

    angular.extend(this, { // VARIABLES
      activityTag: '',
      action: '',
      parent: {},
      children: {},
      isEditing: false,
      title: '',
      description: '',
      inConsolidation: Validations.inConsolidation(currentModule),
      inInvestigation: Validations.inInvestigation(currentModule),
      inAcademicManagement: Validations.inAcademicManagement(currentModule),
      plannedHours: 0,
      startDate: null,
      endDate: null,
      rangeType: 2,
      typePeriod: [],
      periodsArray: {},
      minStartDate: moment().toDate(),
      minEndDate: new Date(),
      sentForm: false
    })

    angular.extend(this, { // METHODS
      hasError: Validations.hasError,
      showErrorMessages: Validations.showErrorMessages,
      startDateChange: startDateChange,
      validAdd: (form) => Validations.validateForm(form) || !validPeriods(),
      close: () => $mdDialog.hide(),
      toggleTypePeriod: (type) => Number(this.rangeType) === type,
      accept: () => addActivity(this),
      validateCheklist: () => Number(this.rangeType) === 1 ? !periodsExist(extractPeriodsIds(this.periodsArray)) : false,
      capitalize: (str) => str.charAt(0).toUpperCase() + str.slice(1)
    })

    this.$onInit = () => {
      let download = WorkPlanModalSrv.getVariable()
      getPeriodList({
        workplanId: this.workplanId,
        teacherId: this.teacherId,
        name: this.name
      }).then(data => {
        this.typePeriod = data.status ? data.listPeriods : console.log('Comunications problem')
      })
      this.parent = download[0]
      this.children = download[1] ? download[1] : null
      if (this.children) {
        this.action = 'editar'
        this.description = objHas(this.children, 'description') ? this.children.description : ''
        this.title = Reflect.has(this.children, 'name') ? this.children.name : ''
        this.plannedHours = objHas(this.children, 'hoursPlanned') ? this.children.hoursPlanned : ''
        if (objHas(this.children, 'timeRangeTypeId')) {
          this.rangeType = this.children.timeRangeTypeId
          switch (this.children.timeRangeTypeId) {
            case 1:
              this.children.periodId.split(',').forEach(id => {
                this.periodsArray[id] = true
              })
              break
            case 2:
              this.startDate = this.children.startDate
              this.endDate = this.children.endDate
              break
          }
        }
      } else {
        this.action = 'agregar'
      }
      this.activityTag = isProjectsType(this.parent) ? 'proyecto' : (isProductsType(this.parent) ? 'producto' : 'proyecto')
    }
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/modals/add-custom.js